import { WatchQueryFetchPolicy } from "@apollo/client";

export const mainApiConfig = {
    endpoint: '/graphql',
    blobUploadEndpoint: '/api/blobs',
    blobDownloadEndpoint: '/api/blobs/redirectToUrl',
    defaultFetchPolicy: 'cache-and-network' as WatchQueryFetchPolicy,
    //defaultFetchPolicy: 'cache-first' as WatchQueryFetchPolicy,
};